import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { AlarmFilterUI, AlarmWithInfo } from "./models/Alarm";

export default class AlarmsVuexModule extends AbacoVuexModule {

    @State() curAlarm!: AlarmWithInfo | null;
    @State() curAlarmFilter!: AlarmFilterUI | null;
    @State() curAlarmGroupCode!: string | null;
}

